export class APIConfig {
  static readonly API_WEBPROTOCOL = 'https://';
  static readonly API_HOSTNAME = 'api.pa.aws.thorogood.com';
   //static readonly API_BASEURL = 'http://localhost:8000';
  static readonly API_BASEURL = APIConfig.API_WEBPROTOCOL + APIConfig.API_HOSTNAME;
  static readonly API_PROJECT_ROLLING_URL = APIConfig.API_BASEURL + '/rollingProject/';
  static readonly API_PROJECT_ALL_URL = APIConfig.API_BASEURL + '/allProject/';
  static readonly API_PRINCE_URL = APIConfig.API_BASEURL + '/princeStage/';
  static readonly API_CATEGORY_URL = APIConfig.API_BASEURL + '/category/';
  static readonly API_QUESTION_URL = APIConfig.API_BASEURL + '/question/';
  static readonly API_RESPONSE_URL = APIConfig.API_BASEURL + '/response/';
  static readonly API_STATUS_URL = APIConfig.API_BASEURL + '/status/';
  static readonly API_RESPONSE_OPTION_URL = APIConfig.API_BASEURL + '/responseOption/';
  static readonly API_USER_URL = APIConfig.API_BASEURL + '/user/';
  static readonly API_LOGIN_URL = APIConfig.API_BASEURL + '/login/';
  static readonly API_LOGOUT_URL = APIConfig.API_BASEURL + '/logout/';
}



// WEBPACK FOOTER //
// C:/Users/Pujaalaxmi.K/Documents/PAA-Angular version 2/src/app/app.constant.ts